export function empty() {
    return new EmptyFilter();
}

export function where(filterString, kendoFilter?) {
    if (!filterString) {
        return new EmptyFilter();
    }

    return new WhereFilter(filterString, kendoFilter);
}

export function forOperator(operator, arg1, arg2, kendoFilter?) {
    return where(arg1 + " " + operator + " " + arg2, kendoFilter);
}

export function forFunction(name, arg1, arg2, kendoFilter?) {
    return where(name + "(" + arg1 + ", " + arg2 + ")", kendoFilter);
}

export function equals(property, value) {
    var nonEscapedValue = value;

    if ($.type(value) == "string") {
        value = escapeString(value);
    }

    return forOperator("eq", property, value, {
        field: property,
        operator: "eq",
        value: nonEscapedValue
    });
}

export function doesNotEqual(property, value) {
    var nonEscapedValue = value;

    if ($.type(value) == "string") {
        value = escapeString(value);
    }

    return forOperator("ne", property, value, {
        field: property,
        operator: "neq",
        value: nonEscapedValue
    });
}

export function isIn(property, values) {
    return any($.map(values, function (value) {
        return equals(property, value);
    }));
}

export function isNotIn(property, values) {
    return all($.map(values, function (value) {
        return doesNotEqual(property, value);
    }));
}

export function greaterThan(property, value) {
    var nonEscapedValue = value;

    if ($.type(value) == "string") {
        value = escapeString(value);
    }

    return forOperator("gt", property, value, {
        field: property,
        operator: "gt",
        value: nonEscapedValue
    });
}

export function lessThan(property, value) {
    var nonEscapedValue = value;

    if ($.type(value) == "string") {
        value = escapeString(value);
    }

    return forOperator("lt", property, value, {
        field: property,
        operator: "lt",
        value: nonEscapedValue
    });
}

export function greaterThanOrEqual(property, value) {
    var nonEscapedValue = value;

    if ($.type(value) == "string") {
        value = escapeString(value);
    }

    return forOperator("ge", property, value, {
        field: property,
        operator: "gte",
        value: nonEscapedValue
    });
}

export function lessThanOrEqual(property, value) {
    var nonEscapedValue = value;

    if ($.type(value) == "string") {
        value = escapeString(value);
    }

    return forOperator("le", property, value, {
        field: property,
        operator: "lte",
        value: nonEscapedValue
    });
}

export function startsWith(property, value) {
    if ($.isArray(property)) {
        return any($.map(property, function (p) {
            return startsWith(p, value);
        }));
    }

    if (!($.trim(value))) {
        return empty();
    }

    return forFunction("startswith", property, escapeString(value, ""), {
        field: property,
        operator: "startswith",
        value: value
    });
}

export function endsWith(property, value) {
    if ($.isArray(property)) {
        return any($.map(property, function (p) {
            return endsWith(p, value);
        }));
    }

    if (!($.trim(value))) {
        return empty();
    }

    return forFunction("endswith", property, escapeString(value, ""), {
        field: property,
        operator: "endswith",
        value: value
    });
}

export function contains(property, value) {
    if ($.isArray(property)) {
        return any($.map(property, function (p) {
            return contains(p, value);
        }));
    }

    if (!($.trim(value))) {
        return empty();
    }

    return forFunction("substringof", escapeString(value, ""), property, {
        field: property,
        operator: "contains",
        value: value
    });
}

export function doesNotContain(property, value) {
    if (!($.trim(value))) {
        return empty();
    }

    return not(contains(property, value), {
        field: property,
        operator: "doesnotcontain",
        value: value
    });
}

export function countEquals(property, value) {
    return forOperator("eq", "length(" + property + ")", value || 0);
}

export function countDoesNotEqual(property, value) {
    return forOperator("ne", "length(" + property + ")", value || 0);
}

export function isNull(property) {
    return equals(property, null);
}

export function isNotNull(property) {
    return doesNotEqual(property, null);
}

export function isNullOrEmpty(property) {
    return equals(property, null).orEquals(property, "");
}

export function isNotNullOrEmpty(property) {
    return doesNotEqual(property, null).andDoesNotEqual(property, "");
}

export function isTrue(property) {
    return equals(property, true);
}

export function isNotTrue(property) {
    return doesNotEqual(property, true);
}

export function isFalse(property) {
    return equals(property, false);
}

export function not(notFilter, kendoFilter?) {
    if (notFilter.isEmptyFilter) {
        return empty();
    }
    return where("not (" + notFilter + ")", kendoFilter);
}

export function all(...filters);
export function all(filters) {
    if ($.isArray(filters)) {
        filters = filters || [];
    } else {
        filters = $.makeArray(arguments);
    }

    return new AllFilter(filters);
}

export function any(...filters);
export function any(filters) {
    if ($.isArray(filters)) {
        filters = filters || [];
    } else {
        filters = $.makeArray(arguments);
    }
    return new AnyFilter(filters);
}

export const kendoFilterMap = {
    "startswith": "startsWith",
    "endswith": "endsWith",
    "contains": "contains",
    "doesnotcontain": "doesNotContain",
    "eq": "equals",
    "neq": "doesNotEqual",
    "gt": "greaterThan",
    "lt": "lessThan",
    "gte": "greaterThanOrEqual",
    "lte": "lessThanOrEqual",
    "isnull": "isNull",
    "isnotnull": "isNotNull",
    "isempty": "isNullOrEmpty",
    "isnotempty": "isNotNullOrEmpty",
    "istrue": "isTrue",
    "isfalse": "isFalse"
};

export function createFromKendoFilter(kendoFilter) {
    var logic = kendoFilter.logic || "and", // logic = "and" or "or"
        newFilter = empty();

    if (kendoFilter.filters) {
        $.each(kendoFilter.filters, function (index, childKendoFilter) {
            newFilter = newFilter[logic](createFromKendoFilter(childKendoFilter));
        });
    } else {
        var filterToApply = kendoFilterMap[kendoFilter.operator],
            trimmedField = $.trim(kendoFilter.field),
            trimmedValue = typeof kendoFilter.value === "string" ? $.trim(kendoFilter.value) : kendoFilter.value;
        if (filterToApply && trimmedField) {
            newFilter = newFilter.add(logic, filterToApply, [trimmedField, trimmedValue]);
        }
    }

    newFilter.kendoFilter = kendoFilter;
    return newFilter;
}

export function toKendoFilter(zFilter?) {
    if (!zFilter) {
        return undefined;
    } else {
        return zFilter.kendoFilter;
    }
}

export function escapeString(value, defaultValue?) {
    if (value === null || value === undefined) {
        return defaultValue || "null";
    }
    return "'" + encodeURIComponent(value.replaceAll("'", "''")) + "'";
}

export function parenthesize(value) {
    return "(" + value + ")";
}

export const Filter = function () {
};

Filter.prototype = {
    and: function (andFilter) {
        if ($.type(andFilter) == "string") {
            andFilter = where(andFilter);
        }
        return all(this, andFilter);
    },
    or: function (orFilter) {
        if ($.type(orFilter) == "string") {
            orFilter = where(orFilter);
        }
        return any(this, orFilter);
    },
    add: function (logic, filterToApply, args) {
        if (logic != "and" && logic != "or") {
            return empty();
        }
        var newFilter = filter[filterToApply].apply(null, args);
        return this[logic](newFilter);
    }
};

// Loop through function names listed here to create methods for chaining.
// We can take a filter and say filter = filter.equals(...).andStartsWith(...).andIsNotNull(...) etc. to build up a filter.
var functionNames = [
    "equals", "doesNotEqual", "doesNotContain", "greaterThan", "lessThan", "greaterThanOrEqual", "lessThanOrEqual", "startsWith", "endsWith",
    "contains", "countEquals", "countDoesNotEqual", "isNull", "isNotNull", "isNullOrEmpty", "isNotNullOrEmpty", "isTrue", "isNotTrue", "isFalse", "not", "all", "any", "where"
];
var filter = { equals, doesNotEqual, doesNotContain, greaterThan, lessThan, greaterThanOrEqual, lessThanOrEqual, startsWith, endsWith,
    contains, countEquals, countDoesNotEqual, isNull, isNotNull, isNullOrEmpty, isNotNullOrEmpty, isTrue, isNotTrue, isFalse, not, all, any, where };
$.each(functionNames, function (index, functionName) {
    var capitalized = functionName.charAt(0).toUpperCase() + functionName.slice(1),
        andName = "and" + capitalized,
        orName = "or" + capitalized;

    Filter.prototype[andName] = function () {
        return this.add("and", functionName, arguments);
    };

    Filter.prototype[orName] = function () {
        return this.add("or", functionName, arguments);
    };
});

export const EmptyFilter = function () {
    this.isEmptyFilter = true;

    $.extend(this, new Filter());
};

EmptyFilter.prototype = {
    toString: function () {
        return "";
    }
};

export const WhereFilter = function (filterString, kendoFilter) {
    this.filterString = filterString;
    this.kendoFilter = kendoFilter;

    $.extend(this, new Filter());
};

WhereFilter.prototype = {
    toString: function () {
        return this.filterString;
    }
};

export const AllFilter = function (filters: any[]) {
    this.isAllFilter = true;

    if (filters.length == 2 && filters[0].isAllFilter) {
        // if we have an all filter plus another filter, combine into one all filter so that when we do toString()
        // we don't have tons of unnecessary parentheses
        this.filters = filters[0].filters.slice();
        if (!filters[1].isEmptyFilter && (!(filters[1].filters && filters[1].filters.length == 0))) {
            this.filters.push(filters[1]);
        }
    } else {
        // filter out empty filters and all/any filters without any filters
        this.filters = $.grep(filters, function (f) { return f && !f.isEmptyFilter && (!(f.filters && f.filters.length == 0)); }) || [];
    }

    this.kendoFilter = {
        logic: "and",
        filters: []
    };

    var array = this.kendoFilter.filters;
    $.each(this.filters, function (index, condition) {
        array.push(condition.kendoFilter);
    });

    $.extend(this, new Filter());
};

AllFilter.prototype = {
    toString: function () {
        if (this.filters.length == 1) {
            return this.filters[0].toString();
        }
        return $.map(this.filters, parenthesize).join(" and ");
    }
};

export const AnyFilter = function (filters: any[]) {
    this.isAnyFilter = true;

    if (filters.length == 2 && filters[0].isAnyFilter) {
        // if we have an any filter plus another filter, combine into one any filter so that when we do toString()
        // we don't have tons of unnecessary parentheses
        this.filters = filters[0].filters.slice();
        if (!filters[1].isEmptyFilter && (!(filters[1].filters && filters[1].filters.length == 0))) {
            this.filters.push(filters[1]);
        }
    } else {
        // filter out empty filters and all/any filters without any filters
        this.filters = $.grep(filters, function (f) { return !f.isEmptyFilter && (!(f.filters && f.filters.length == 0)); }) || [];
    }

    this.kendoFilter = {
        logic: "or",
        filters: []
    };

    var array = this.kendoFilter.filters;
    $.each(this.filters, function (index, condition) {
        array.push(condition.kendoFilter);
    });

    $.extend(this, new Filter());
};

AnyFilter.prototype = {
    toString: function () {

        if (this.filters.length == 1) {
            return this.filters[0].toString();
        }

        return $.map(this.filters, parenthesize).join(" or ");
    }
};
